import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { Box, Typography } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import { stopEditorEvents } from './AttrFields';

interface BlockFrameProps {
    type: string;
    icon: SvgIconComponent;
    title: string;
    meta?: React.ReactNode;
    /** Controls rendered right-aligned in the header (switches, add buttons) */
    actions?: React.ReactNode;
    selected: boolean;
    children: React.ReactNode;
    /** No padding for the body (tables, iframes) */
    flush?: boolean;
}

/**
 * Card chrome shared by all atom block node views: header with icon badge
 * (neutral grey, design rule), title, meta text and actions, then the body.
 * Keyboard/mouse events inside the body do not reach ProseMirror.
 */
export const BlockFrame: React.FC<BlockFrameProps> = ({ type, icon: Icon, title, meta, actions, selected, children, flush }) => (
    <NodeViewWrapper className={`oa-block oa-block-frame${selected ? ' is-selected' : ''}`} data-type={type}>
        <Box className="oa-block-frame-head">
            <span className="oa-block-frame-icon"><Icon fontSize="small" /></span>
            <Typography variant="subtitle2" component="span" className="oa-block-frame-title">{title}</Typography>
            {meta && <Typography variant="caption" color="text.secondary" className="oa-block-frame-meta">{meta}</Typography>}
            {actions && <Box className="oa-block-frame-actions" {...stopEditorEvents}>{actions}</Box>}
        </Box>
        <Box className={`oa-block-frame-body${flush ? ' is-flush' : ''}`} {...stopEditorEvents}>
            {children}
        </Box>
    </NodeViewWrapper>
);
